module.exports = __webpack_public_path__ + "static/media/07_.dde02868.png";